import React from 'react';
import { useFormContext } from 'react-hook-form';
import i18n from 'I18n';
import { Image } from 'react-bootstrap';

import CustomSwitchButton from 'components/base/CustomSwitchButton';
import CustomTitleWithInput, { CustomInput } from 'components/base/CustomTitleWithInput';
import { CustomTitleLabel } from 'components/earning/CustomBaseComponments';

import { SectionTopTitle } from 'components/base/CommonComponent';
import { LevelErrorHandleFields } from 'containers/engagement/level/LevelErrorHandle';
import ErrorFieldMessage, { hasError } from 'components/base/ErrorFieldMessage';
import AuthButton from 'components/base/AuthButton';
import deleteImage from '../../../assets/images/deleteIcon.png';
import './LevelBenefits.scss';

const LevelBenefits = ({
  language,
}) => {
  const {
    formState: { errors },
    setValue,
    watch,
  } = useFormContext();

  const watchLevelBenefits = watch('levelBenefits') || [{}];

  const rewardItem = (item, index) => {
    const titleField = `levelBenefits[${index}].translations.${language}.title`;
    const contentField = `levelBenefits[${index}].translations.${language}.content`;
    const highlightField = `levelBenefits[${index}].highlight`;

    const watchTitle = watch(titleField);
    const watchContent = watch(contentField);
    const watchHighlight = watch(highlightField);

    return (
      <div>
        <div className='level-benefits-section-title-container'>
          <label className='create-section-label level-benefits-section-title'>
            {`# ${index + 1}`}
          </label>
          <AuthButton
            children={
              <Image src={deleteImage} className="custom-delete-btn" />
            }
            customClass="custom-delete-btn"
            action={() => {
              // eslint-disable-next-line array-callback-return
              const newList = watchLevelBenefits?.filter((item1, index1) => {
                // eslint-disable-next-line eqeqeq
                if (index != index1) {
                  return item1;
                }
              });
              setValue('levelBenefits', newList, { shouldDirty: true });
            }}
          />
        </div>
        <div className='level-benefits-input-container'>
          <CustomInput
            onChange={({ target }) => {
              setValue(titleField, target.value, { shouldDirty: true, });
            }}
            defaultValue={watchTitle}
            inputCustomClass={"level-benefits-title"}
            error={hasError(errors, contentField)}
          />
        </div>
        <div className='level-benefits-input-container'>
          <textarea
            onChange={({ target }) => {
              setValue(contentField, target.value, { shouldDirty: true, });
            }}
            className={`custom-markdown-area-title level-benefits-content ${hasError(errors, contentField) ? 'error-field' : ''}`}
            value={watchContent}
          />
        </div>
        <ErrorFieldMessage
          id={contentField}
          error={hasError(errors, contentField)}
          message={LevelErrorHandleFields.titleAndContent}
        />
        <CustomTitleLabel title="Highlight for this level" />
        <div>
          <CustomSwitchButton
            defaultChecked={watchHighlight}
            onChange={(isChecked) => {
              setValue(highlightField, isChecked, { shouldDirty: true });
            }}
          />
        </div>
      </div>
    )
  }

  return (
    <>
      <SectionTopTitle title={i18n.t("levelBenefits", { locale: language })} />

      {watchLevelBenefits?.map((item, index) => rewardItem(item, index))}
      <AuthButton
        title={i18n.t("addANewBenefit", { locale: language })}
        customClass="btn-back-button-common level-benefits-add-button"
        action={() => {
          setValue('levelBenefits', [...watchLevelBenefits, {}]);
        }}
      />
    </>
  );
}

export default LevelBenefits;
